import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { feedbackModalHide } from 'Global/Stores/modals'
import { sendFeedback } from 'Global/Stores/feedback'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    hasError: selectors.hasError(state),
    isPending: selectors.isPending(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    close: () => dispatch(feedbackModalHide()),
    sendFeedback: (subject, feedback, feedbackType, user) => dispatch(sendFeedback(subject, feedback, feedbackType, user)),
  })

  Enhancer.displayName = 'FeedbackModalEnhancer'

  Enhancer.propTypes = {
    close: PropTypes.func.isRequired,
    hasError: PropTypes.bool.isRequired,
    isPending: PropTypes.bool.isRequired,
    sendFeedback: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
